import Component from '../core/Component'
import Scroll, { getScroll } from '../services/Scroll'

export const STATES = {
    DRAGGABLE: 'is-draggable',
    PINNED: 'is-pinned',
    READY: 'is-ready'
}

export default class DragTable extends Component {
    constructor(element) {
        super(element)

        this.ref = {
            container: null,
            table: null,
            scrollRows: [],
            fixedRows: [],
        }

        this.isOverflowing = false
        this.isDragging = false
    }

    prepare() {
        this.nameHeader = this.ref.fixedRows[0]
        this.legendHeader = this.ref.scrollRows[0]

        Scroll.on('scroll', this.handleScroll)
        Scroll.on('resize', this.handleResize)
        this.handleResize()
    }

    destroy() {
        Scroll.off('scroll', this.handleScroll)
        Scroll.off('resize', this.handleResize)
    }

    handleResize = () => {
        let windowY = getScroll().y
        let tableRect = this.element.getBoundingClientRect()

        this.element.top = tableRect.top + windowY
        this.element.bottom = this.element.top + tableRect.height

        this.rowHeight = this.ref.fixedRows[this.ref.fixedRows.length-1].scrollHeight
        this.headerHeight = this.ref.fixedRows[0].scrollHeight

        // match rows in height
        this.ref.fixedRows.map(($element, index) => {
            let $scrollRowEl = this.ref.scrollRows[index]

            if ($element.scrollHeight > $scrollRowEl.scrollHeight) {
                this.ref.scrollRows[index].style.height = $element.scrollHeight + 'px'
            } else {
                this.ref.fixedRows[index].style.height = $scrollRowEl.scrollHeight + 'px'
            }
        })

        // resolve dragging
        if (this.ref.table.scrollWidth > this.ref.container.getBoundingClientRect().width) {
            this.initDragging()
        } else {
            this.endDragging()
        }

        setTimeout(() => {
            this.element.classList.add(STATES.READY)
        }, 0)
    }

    handleScroll = event => {
        let windowY = event.offset.y

        if (windowY >= this.element.top && windowY <= this.element.bottom - 2*this.rowHeight - this.headerHeight) {
            this.pin(windowY)
        } else {
            if (windowY < this.element.top) {
                this.unpin(this.element.top)
            } else {
                this.unpin(this.element.bottom - 2*this.rowHeight - this.headerHeight)
            }
        }
    }

    pin(offset) {
        this.nameHeader.style.transform = `translate3d(0,${offset-this.element.top}px,0)`
        this.legendHeader.style.transform = `translate3d(0,${offset-this.element.top}px,0)`
        this.element.classList.add(STATES.PINNED)
    }

    unpin(staticOffset) {
        if (!this.element.classList.contains(STATES.PINNED)) return

        this.nameHeader.style.transform = `translate3d(0,${staticOffset-this.element.top}px,0)`
        this.legendHeader.style.transform = `translate3d(0,${staticOffset-this.element.top}px,0)`
        this.element.classList.remove(STATES.PINNED)
    }

    handleMouseDown = event => {
        this.isDragging = true
        this.initialX = event.clientX
        this.initialScroll = this.ref.container.scrollLeft

    }
    handleTouchDown = event => {
        this.isDragging = true
        this.initialX = event.touches[0].clientX
        this.initialScroll = this.ref.container.scrollLeft
    }

    handleMouseUp = event => {
        this.isDragging = false
    }
    handleTouchUp = event => {
        this.isDragging = false
    }

    handleMouseMove = event => {
        if (!this.isDragging) {
            return
        }

        this.currX = event.clientX
        this.move()
    }
    handleTouchMove = event => {
        if (!this.isDragging) {
            return
        }
        this.currX = event.touches[0].clientX
        this.move()
    }

    move() {
        this.ref.container.scrollLeft = this.initialScroll + this.initialX - this.currX
    }

    initDragging() {
        this.ref.table.addEventListener('mousedown', this.handleMouseDown)
        this.ref.table.addEventListener('mousemove', this.handleMouseMove)
        document.addEventListener('mouseup', this.handleMouseUp)

        this.ref.table.addEventListener('touchstart', this.handleTouchDown)
        this.ref.table.addEventListener('touchmove', this.handleTouchMove)
        document.addEventListener('touchend', this.handleTouchUp)

        this.element.classList.add(STATES.DRAGGABLE)
        this.isOverflowing = true
    }

    endDragging() {
        this.ref.table.removeEventListener('mousedown', this.handleMouseDown)
        this.ref.table.removeEventListener('mousemove', this.handleMouseMove)
        document.removeEventListener('mouseup', this.handleMouseUp)

        this.ref.table.removeEventListener('touchstart', this.handleTouchDown)
        this.ref.table.removeEventListener('touchmove', this.handleTouchMove)
        document.removeEventListener('touchend', this.handleTouchUp)

        this.element.classList.add(STATES.DRAGGABLE)
        this.isOverflowing = true
    }
}
